define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml",
	"./NewColorwayMixin",
], function(declare,New,xml,NewColorwayMixin) {

	return declare([New, NewColorwayMixin], {
		/**
		 * Add field for adding to BOM
		 */
		onCreatePopupDefView: function(defView) {
			this._addBomField(this.getParent(), defView);
		},

		toWriterRequest: function() {
			var fd = this.getFormData();
			let	call = this.inherited(arguments);
			let colorModels = [];
			let colorModelsValue = [];
			const colorFieldsName = ["ColorSpecification/RGBTriple", "ColorSpecification/RGBHex", "ColorSpecification/RGB", "ColorSpecification/CMYK"];
			// leave off ColorSpecification if CreateColorSpecification is unchecked
			if (fd.getFieldValue("CreateColorSpecification")) {
				fd.getFieldValue("ColorSpecification", true);
				colorFieldsName.forEach( fieldName => {
					const f = fd.getField(fieldName);
					if (f && f.getValue()){
						colorModelsValue.push(f.getValue());
						colorModels.push(fieldName.replace(/^.*[\\\/]/, ''));
					}
				})
				call.addParameter("ColorModels", xml.ATTR_STRINGLIST, colorModels);
				call.addParameter("ColorModelsValue", xml.ATTR_STRINGLIST, colorModelsValue);
			}

			return call;
		},

		validateNode: function(url, bWithAttributes) {
			if (this.m_formData.getFieldValue("CreateColorSpecification")) {
				this.inherited(arguments);
			} else {
				this.m_writer.validateNode(url, bWithAttributes);
			}
		},

		publish: function() {
			// summary: call method to add to BOM(s) after all other operations
			this._writeBomField(this.m_urlParent, this.m_urlNode);
			this.inherited(arguments);
		}
	});
});
